module.exports = __webpack_public_path__ + "img/AP_logo_full.8a75f205.png";